import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { resultMediaResourceDefinition } from '../utils/queryDefinitions';

export default function useResultMedia({ breedId, breederProfileId, enabled }) {
  const {
    value: { result_photos: resultPhotos, result_video: resultVideo },
    isSuccess
  } = useResourceQuery({
    ...resultMediaResourceDefinition(breedId, breederProfileId),
    enabled: Boolean(enabled && breedId && breederProfileId)
  });

  return {
    resultPhotos: resultPhotos || [],
    resultVideo: resultVideo || null,
    isLoaded: isSuccess
  };
}
